export default "__VITE_ASSET__Dgz8NlCg__"